import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'dfFullDate'
})
export class DfFullDatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(date: moment.Moment, withTime: boolean = true, withoutSeconds: boolean = false): string {
    if (!date || !date.isValid()) {
      return this.translate.instant('pipe.fulldate.error');
    }

    if (withTime) {
      if (withoutSeconds) {
        return date.format('MM/DD/YYYY HH:mm')
      }
      return date.format('MM/DD/YYYY HH:mm:ss');
    }

    return date.format('MM/DD/YYYY');
  }

}
